export default {
    createChart: '<b>astrolink.com.br</b>',
    shareButton: 'Compartilhar',
    fileName: 'mapa-astral',
    extraMapFileName: 'mapa-extra'
};